// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8426fdae","396":"2d93259f","455":"1bad414a","977":"553e77bc"}[chunkId] + ".chunk.js";
};